import { defineMessages } from 'react-intl';

export default defineMessages({
  userPinModalAssigneeText: {
    defaultMessage: 'This PIN code is assigned to:',
    description: 'User pin modal - assignee text',
    id: 'userPinModalAssigneeText',
  },
  userPinModalCancelButton: {
    defaultMessage: 'Cancel',
    description: 'User pin modal - cancel button',
    id: 'userPinModalCancelButton',
  },
  userPinModalConfirmButton: {
    defaultMessage: 'Save & Send pin',
    description: 'User pin modal - confirm button',
    id: 'userPinModalConfirmButton',
  },
  userPinModalConfirmButtonLoginLess: {
    defaultMessage: 'Save pin',
    description: 'User pin modal - confirm button LoginLess',
    id: 'userPinModalConfirmButtonLoginLess',
  },
  userPinModalErrorMessageAlreadyExists: {
    defaultMessage: 'This PIN is already in use - choose a different one',
    description: 'User pin modal - error message for existing PIN',
    id: 'userPinModal.errorMessage.alreadyExists',
  },
  userPinModalErrorMessageUnsecure: {
    defaultMessage: 'This PIN is too easy to guess - choose a more secure one, avoid sequences or repeating numbers',
    description: 'User pin modal - error message for easy to guess PIN',
    id: 'userPinModal.errorMessage.unsecure',
  },
  userPinModalErrorMessageWrongLength: {
    defaultMessage: 'PIN must be {pinLength} digits long as defined in site settings',
    description: 'User pin modal - error message for wrong length PIN',
    id: 'userPinModal.errorMessage.wrongLength',
  },
  userPinModalInfoText: {
    defaultMessage: 'Don’t forget to pass the assigned PIN to the user.',
    description: 'User pin modal - info text',
    id: 'userPinModalInfoText',
  },
  userPinModalTitle: {
    defaultMessage: 'Generate new PIN',
    description: 'User pin modal - title',
    id: 'userPinModalTitle',
  },
});
